export const actionTypePrefix = '@@DEVIATIONS';
